import { isRunningOnServer } from "@snapchat/web-env";
export function backendEndpoint() {
    if (isRunningOnServer()) {
        const endpoint = process.env.NEXT_PUBLIC_BACKEND_ENDPOINT;
        if (!endpoint) {
            throw new Error("Missing value for environment variable BACKEND_ENDPOINT");
        }
        return endpoint;
    }
    else {
        return "/api/proxy-to-backend";
    }
}
export const FALLBACK_ORIGIN = "https://www.snapchat.com";
